import CircularProgress from '@material-ui/core/CircularProgress';
import clsx from 'clsx';
import { CART_OPEN } from 'constants/Images';
import Image from 'next/image';
import React from 'react';
import styles from './styles.module.css';

interface Props {
  className?: string;
  children: React.ReactNode;
  text?: string;
  disabled?: boolean;
  isBlur?: boolean;
  isLoading?: boolean;
  limit?: number;
  totalVisible: number;
  total: number;
  onLoadMoreComment: (limit: number) => void;
}

const LoadMoreWrapper = ({
  className,
  isBlur = true,
  isLoading = false,
  disabled = false,
  children,
  text,
  limit = 5,
  totalVisible,
  total,
  onLoadMoreComment,
}: Props) => {
  const commentRemaining = total - totalVisible;
  const hasMore = totalVisible < total;
  const showText = text || `Xem thêm ${commentRemaining > limit ? limit : commentRemaining} ý kiến`;

  if (disabled) {
    return <>{children}</>;
  }

  return (
    <div className={clsx(className, styles.readMoreWrapper, { [styles.isBlur]: totalVisible < total ? isBlur : false })}>
      {children}
      {hasMore && (
        <div role="button" className={styles.readMoreAction} onClick={() => onLoadMoreComment(commentRemaining)}>
          <p className={styles.textLink}>{showText}</p>
          <div className={styles.icon}>
            {isLoading ? (
              <CircularProgress style={{ color: '#1B4BE5' }} size={14} thickness={4} />
            ) : (
              <Image src={CART_OPEN} width={16} height={16} alt="open icon" />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadMoreWrapper;

